var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoresult = function SvgNoresult(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-results-a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "81.04%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E8E8E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-results-b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F8F8F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("circle", {
    id: "no-results-d",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("filter", {
    id: "no-results-c",
    width: "105.4%",
    height: "107.1%",
    x: "-1.8%",
    y: "-1.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    values: "0 0 0 0 0.866666667   0 0 0 0 0.866666667   0 0 0 0 0.866666667  0 0 0 0.25 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "no-results-f",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("filter", {
    id: "no-results-e",
    width: "114.3%",
    height: "114.3%",
    x: "-7.1%",
    y: "-7.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    "in": "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0.866666667   0 0 0 0 0.866666667   0 0 0 0 0.866666667  0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "no-results-h",
    d: "M60,120 C93.137085,120 120,93.137085 120,60 C120,26.862915 95.137085,62 62,62 C28.862915,62 0,26.862915 0,60 C0,93.137085 26.862915,120 60,120 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "no-results-g",
    width: "103.3%",
    height: "105.4%",
    x: "-1.7%",
    y: "-2.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -4,
    "in": "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0.866666667   0 0 0 0 0.866666667   0 0 0 0 0.866666667  0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-results-i",
    x1: "37.798%",
    x2: "73.975%",
    y1: "20.685%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "url(#no-results-a)",
    d: "M104,12.5 C104.966498,12.5 105.841498,12.8917508 106.474874,13.5251263 C107.108249,14.1585017 107.5,15.0335017 107.5,16.000007 L107.5,16.000007 L107.501116,95.8370847 C96.6396312,110.210916 79.4046403,119.5 60,119.5 C40.59625,119.5 23.3619502,110.211769 12.5003789,95.839063 L12.5003789,95.839063 L12.5,16 C12.5,15.0335017 12.8917508,14.1585017 13.5251263,13.5251263 C14.1585017,12.8917508 15.0335017,12.5 16,12.5 L16,12.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-results-b)",
    d: "M80,66 L80,70 L0,70 L0,66 L80,66 Z M80,56 L80,60 L0,60 L0,56 L80,56 Z M80,46 L80,50 L0,50 L0,46 L80,46 Z M80,36 L80,40 L0,40 L0,36 L80,36 Z M80,26 L80,30 L0,30 L0,26 L80,26 Z M80,16 L80,20 L0,20 L0,16 L80,16 Z M80,8 L80,12 L0,12 L0,8 L80,8 Z M80,0 L80,4 L0,4 L0,0 L80,0 Z",
    transform: "translate(20 28)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#DDD",
    transform: "translate(16.5 16.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 1.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 87.92 7.18)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 8,
    x: 21,
    y: 54,
    fill: "#777",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#337AB7",
    d: "M34,68 C35.1045695,68 36,68.8954305 36,70 L36.0001036,84.6804382 C30.6688664,85.1280976 25.2835593,84.8614685 19.9994098,83.8812006 L20,70 C20,68.8954305 20.8954305,68 22,68 L34,68 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 27,
    y: 66,
    stroke: "#DDD",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#no-results-c)",
    xlinkHref: "#no-results-d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 25,
    fill: "#F8F8F8",
    stroke: "#CCC",
    strokeLinejoin: "square",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#no-results-e)",
    xlinkHref: "#no-results-f"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#no-results-g)",
    xlinkHref: "#no-results-h"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.36,
    cy: 63.582,
    r: 17,
    fill: "url(#no-results-i)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoresult, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noresult.8552860fe958ae02b2273de0ee88f0f0.svg";
export { ForwardRef as ReactComponent };